import {
  Activity,
  Bot,
  Building2,
  Circle,
  ClipboardList,
  LayoutDashboard,
  Mail,
  PhoneCall,
  Repeat,
  Settings,
  ToggleRight,
  UserPlus,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * Map icon names used in apps/admin-cascade/src/portal.config.ts to the
 * Lucide components the Cascade web app actually renders. Add new entries
 * here as the config introduces new icon names.
 */
const ICONS: Record<string, LucideIcon> = {
  Activity,
  Bot,
  Building2,
  ClipboardList,
  LayoutDashboard,
  Mail,
  PhoneCall,
  Repeat,
  Settings,
  ToggleRight,
  UserPlus,
  Users,
};

const FALLBACK_ICON: LucideIcon = Circle;

export function resolveIcon(name: string | undefined): LucideIcon {
  if (!name) return FALLBACK_ICON;
  return ICONS[name] ?? FALLBACK_ICON;
}
